import React, { useEffect, useState } from 'react';
import { Phone } from '@phosphor-icons/react';
import { useI18n } from '@/lib/i18n';

const PHONE_DISPLAY = '+49 152 08483930';
const PHONE_HREF = 'tel:+4915208483930';

export default function CallButton() {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 1200);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <a
      href={PHONE_HREF}
      data-testid="call-button"
      aria-label={`${t.call.tooltip} ${PHONE_DISPLAY}`}
      className="fixed bottom-24 left-4 sm:left-6 z-[90] w-14 h-14 rounded-full bg-[#C5A059] hover:bg-[#B38F4D] text-[#0A1128] shadow-2xl flex items-center justify-center transition-all hover:scale-105 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#C5A059] animate-ping opacity-25" />
      <Phone size={26} weight="fill" className="relative" />
      <span className="absolute left-full ml-3 whitespace-nowrap bg-[#0A1128] text-white text-[11px] tracking-[0.18em] uppercase px-3 py-2 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none hidden sm:block">
        {t.call.tooltip}
      </span>
    </a>
  );
}
